import React from 'react';
import FarmProductCard from './FarmProductCard';

/**
 * Profile wrapper around FarmProductCard.
 * Ensures profile surfaces use marketplace card proportions while enforcing visibility rules.
 */
export default function ProfileProductCard({
  product,
  compact = true,
  isOwner = false,
  isWished = false,
  wishCount = 0,
  onToggleWishlist,
  onEdit,
  onHide,
  onDelete,
  onReport,
}) {
  // Hidden products are owner-only.
  if (product?.hidden && !isOwner) return null;

  return (
    <FarmProductCard
      product={product}
      compact={compact}
      isOwner={isOwner}
      isWished={isWished}
      wishCount={wishCount}
      onToggleWishlist={onToggleWishlist}
      onEdit={onEdit}
      onHide={onHide}
      onDelete={onDelete}
      onReport={onReport}
    />
  );
}
